module.exports = __webpack_public_path__ + "static/img/cert-auth-4.f5efa70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-auth-4.png
// module id = J1J0
// module chunks = 1